{
  "_comment": "[CI-LOCKED] O conteúdo deste ficheiro está bloqueado. São aceites contribuições, mas a validação das alterações pode registar atrasos.",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Controlo Opção $1",
  "ACTIVITY_BOT_SAID_ALT": "O bot $1 disse:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Agente",
  "ACTIVITY_YOU_SAID_ALT": "Disse:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Bot anexado:",
  "ACTIVITY_CODE_ALT": "Exemplo de código: $1",
  "ACTIVITY_CONTENT_CAUTION": "O conteúdo gerado por IA pode estar incorreto",
  "ACTIVITY_CODE_CAUTION": "Código gerado por IA. Reveja e utilize com cuidado",
  "ACTIVITY_ERROR_BOX_TITLE": "Mensagem de erro",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Clique para interagir.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "A mensagem é interativa.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "A mensagem contém uma ou mais ligações.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Falha ao enviar.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Anexou:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 anexo.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 anexos.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 anexos.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 anexos.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 anexos.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Falha ao enviar. [Repetir][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "A enviar",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Enviado às $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Agora mesmo",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Há uma hora",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Há um minuto",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Hoje",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Ontem",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Erro de análise de Cartão Adaptável",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Erro de composição de Cartão Adaptável",
  "ATTACHMENT_AUDIO": "Um clip de áudio.",
  "ATTACHMENT_CARD": "Um cartão: $1 $2 $3",
  "ATTACHMENT_FILE": "Um ficheiro: $1",
  "ATTACHMENT_IMAGE": "Uma imagem",
  "ATTACHMENT_TEXT": "Um texto: $1",
  "ATTACHMENT_VIDEO": "Um clip de vídeo",
  "AVATAR_ALT": "Avatar $1",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Seguinte",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Anterior",
  "CITATION_MODEL_DIALOG_ALT": "Citação",
  "CLOSE_BUTTON_ALT": "Fechar",
  "COLLAPSIBLE_GROUPING_TITLE": "A pensar…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Isto é mostrado quando o bot está a compor mensagens de resposta num grupo, caso não seja fornecido um resumo.",
  "COLLAPSE_BUTTON_LESS": "Mostrar menos",
  "COLLAPSE_BUTTON_LESS.comment": "Este é o texto de um botão de divisa para fechar o grupo de mensagens. Quando o utilizador final clica no botão, o grupo de mensagens é fechado.",
  "COLLAPSE_BUTTON_MORE": "Mostrar mais",
  "COLLAPSE_BUTTON_MORE.comment": "Este é o texto de um botão de divisa para expandir o grupo de mensagens. Quando o utilizador final clica no botão, o grupo de mensagens é expandido.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Ligado",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "A ligar…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Não é possível ligar.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Ocorreu uma interrupção de rede. A restabelecer ligação…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Erro de composição. Verifique a consola ou contacte o programador do bot.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "O estabelecimento da ligação está a demorar mais tempo do que o esperado.",
  "CONNECTIVITY_STATUS_ALT": "Estado de Conectividade: $1",
  "COPY_BUTTON_TEXT": "Copiar",
  "COPY_BUTTON_COPIED_TEXT": "Copiado",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Submeter",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Cancelar",
  "FEEDBACK_FORM_PLACEHOLDER": "Forneça o máximo de detalhes possível, mas não inclua informações privadas ou confidenciais.",
  "FEEDBACK_FORM_TITLE": "Conte-nos sobre a sua experiência",
  "FILE_CONTENT_ALT": "\"$1\"",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Transferir o ficheiro \"$1\"",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Transferir o ficheiro \"$1\" com um tamanho de $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "\"$1\" com um tamanho de $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Abre numa nova janela externa.",
  "RECEIPT_CARD_TAX": "Imposto",
  "RECEIPT_CARD_TOTAL": "Total",
  "RECEIPT_CARD_VAT": "IVA",
  "REFERENCE_LIST_HEADER_ONE": "$1 referência",
  "REFERENCE_LIST_HEADER_FEW": "$1 referências",
  "REFERENCE_LIST_HEADER_MANY": "$1 referências",
  "REFERENCE_LIST_HEADER_OTHER": "$1 referências",
  "REFERENCE_LIST_HEADER_TWO": "$1 referências",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Eliminar anexo $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Eliminar",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Um ficheiro",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Uma imagem",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Não é possível enviar uma mensagem vazia.",
  "SPEECH_INPUT_LISTENING": "A escutar…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Microfone desativado",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Microfone ativado",
  "SPEECH_INPUT_STARTING": "A iniciar…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Seguinte",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Anterior",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Ações sugeridas",
  "TEXT_INPUT_ALT": "Caixa de entrada de mensagens",
  "TEXT_INPUT_PLACEHOLDER": "Escreva a sua mensagem",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Comece a falar...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "A escutar...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "A processar...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Fale para interromper...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Enviar",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Falar",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Carregar ficheiro",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Teclado do telefone",
  "TEXT_INPUT_DROP_ZONE": "Largar ficheiros",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Comprimento da mensagem excedido",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Só suporta entrada de um dígito",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 anexos",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 anexos",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 anexo",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 anexos",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 anexos",
  "TOAST_ACCORDION_FEW": "$1 Notificações: clique aqui para ver os detalhes",
  "TOAST_ACCORDION_MANY": "$1 Notificações: clique aqui para ver os detalhes",
  "TOAST_ACCORDION_OTHER": "$1 Notificações: clique aqui para ver os detalhes",
  "TOAST_ACCORDION_TWO": "$1 Notificações: clique aqui para ver os detalhes",
  "TOAST_ALT_ERROR": "Erro",
  "TOAST_ALT_INFO": "Informações",
  "TOAST_ALT_SUCCESS": "Êxito",
  "TOAST_ALT_WARN": "Aviso",
  "TOAST_DISMISS_BUTTON": "Dispensar",
  "TOAST_TITLE_ALT": "Notificação",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Histórico de chat, prima as teclas de seta para navegar.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "histórico de chat",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "A mensagem é interativa. Prima Shift + tecla de tabulação 2 a 3 vezes para mudar para o histórico de chat. Em seguida, clique na mensagem para interagir.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "A mensagem contém uma ou mais ligações. Prima Shift + tecla de tabulação 2 a 3 vezes para mudar para o histórico de chat. Em seguida, clique na mensagem para interagir.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "A mensagem tem ações sugeridas. Prima Shift Tabulação 2 a 3 vezes para as selecionar.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "A mensagem tem ações sugeridas. Prima $1 para as selecionar.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Falha ao enviar a mensagem.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Novas mensagens disponíveis. Prima $1 para atribuir o foco ao botão \"$2\".",
  "TRANSCRIPT_MORE_MESSAGES": "Mais mensagens",
  "TRANSCRIPT_NEW_MESSAGES": "Novas mensagens",
  "TRANSCRIPT_TERMINATOR_TEXT": "Fim do histórico de chat",
  "TYPING_INDICATOR_ALT": "A mostrar o indicador de escrita",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 está a escrever.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 e outros utilizadores estão a escrever.",
  "VIEW_CODE_BUTTON_TEXT": "Código",
  "VOTE_COMPLETE_ALT": "Comentários registados",
  "VOTE_COMPLETE_ALT.comment": "Destinado ao leitor de ecrã. A etiqueta de um botão com ícones de polegar para cima/baixo. A etiqueta é utilizada quando foram registados comentários.",
  "VOTE_DISLIKE_ALT": "Não Gostar",
  "VOTE_LIKE_ALT": "Gostar"
}